<div class="tagbadge {{cursor}}">
    <ng-content></ng-content>
</div>